var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"sloganArea"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.position > -1),expression:"position > -1"}],staticClass:"slogan"},[_c('router-link',{staticClass:"slogan_text",attrs:{"to":"/company/philosophy#slogan"}},[_vm._v("～DATA CREATES THE FUTURE～"),_c('br'),_c('br'),_vm._v("データの力で未来を切り開く")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }